import React, { useState, useEffect, Suspense, lazy, useRef } from 'react';
import ChatBotPopup from './chat-popup';
import ChatToolbar from './chatToolBar';
import { homePageService } from '../../jwt/_services/home-page-service';
import { useDispatch, useSelector } from 'react-redux';
import { AMIL_ICON, PREDEFINE_ICON1, PREDEFINE_ICON2, USTAD_ICON, USTAD_IMAGE } from '../../common/images-s3';
import { AI_MOSQ, CHAT_HEAD, EMOJI_ICON, HEAD_ICON, imgBack, MSG_SEND } from '../../common/images-svg';
import { commaSeperatedAmount, CURRENCY_SYMBOL, decryptData } from '../../common';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { updateAmount, updateZakatData } from '../../redux/actions/zakatActions';
import { PayNow } from '../../jwt/_services/paynow-service';
import { API_KEY, config } from '../../common/constant';
import { Common, extractZakatData, formatResponse } from '../../common/common';
import { updatePaymentData, updateUserSteps } from '../../redux/actions/userAction';
import { OpenAIService } from '../../jwt/_services/openai-service';
import { updateBusinessAmount, updateTotal } from '../../redux/actions/zakatCalcAction';
import Loader from '../MUIS/loader';
import { enrollmentMethodHeaderData } from '../../section/pay-zakat/type-of-zakat';
import { closeVoiceAssistant, setMicOff, setThreadId } from '../../redux/reducers/aichatbotSlice';
import { optionsHeaderData } from '../../component/questionnaire';
const ImageLoader = lazy(() => import('../../common/image-loader'));

const IslamicChatBot = ({
    ...props
}) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.userReducer);
    const homepage = useSelector(state => state.homepageReducer);
    const zakat = useSelector(state => state.zakatReducer);
    const [showChat, setShowChat] = useState(false);
    const messagesRef = useRef([]);
    const [messages, setMessages] = useState([]);
    const liveBotResponseRef = useRef("");
    const [, stateUpdated] = useState(0);
    const [input, setInput] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isPaymentLoading, setIsPaymentLoading] = useState(false);
    const [sessionId, setSessionId] = useState(null);
    const [hasSentInitialMessage, setHasSentInitialMessage] = useState(false);
    const [predefinedQuestions, setPredefinedQuestions] = useState('');
    const [fileObject, setFileObject] = useState([]);
    const [promptType, setPromptType] = useState(user?.isBusinessPayer ? 'Business' : 'Individual');
    const [isBotTyping, setIsBotTyping] = useState(false);
    const [isShowButton, setIsShowButton] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [file, setFile] = useState([]);
    const [showFile, setShowFile] = useState(false);
    const [attachmentError, setAttachmentError] = useState('');
    const [isRemoveFile, setIsRemoveFile] = useState(false);
    const [isVoiceInput, setIsVoiceInput] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [isDisclaimer, setDisclaimer] = useState('');
    const [isMounted, setIsMounted] = useState(false);
    const [audioChunks, setAudioChunks] = useState([]);
    const latestZakatRef = useRef(null);
    const isDiscardRef = useRef(false);
    const [recordingStatus, setRecordingStatus] = useState('idle');
    const isVoiceAssistantOpen = useSelector((state) => state.aiChatbotSlice.isVoiceAssistantOpen);

    const inputRef = useRef(null);
    const { t } = useTranslation();
    const history = useHistory();
    

    useEffect(() => {
        const fetchWelcomeMessage = async () => {
            try {
                setIsLoading(true);
                setIsBotTyping(true);
                dispatch(closeVoiceAssistant());
                dispatch(setMicOff())
                const payload = {
                    sessionId: sessionId || '',
                    userInput: 'Hi',
                    fileId: '',
                    promptType: promptType
                };

                const data = await OpenAIService.AIChatbot(payload);
                // const data = {
                //     sessionId: "thread_0rrRqRCCsjgTjlLhabIeBQWB",
                //     response: "<div class='assistant-response'>Assalamu'alaikum! I am your personal AI Amil here to assist you in calculating your Zakat according to Singapore’s guidelines. <br><br>To begin, may I ask: How many personal bank accounts do you have, and what was the <b>lowest balance</b> held in each during the past year (in SGD)?</div>",
                //     disclaimer: "<div class='disclaimer' style='font-size: 13px; color: #333; margin-top: 20px; line-height: 1.6; border-top: 1px solid #ccc; padding-top: 10px;'><p style='margin: 0;'> <strong>Privacy First</strong>, no personal or financial data is stored.</p><p style='margin: 0;'> <strong>By using this tool</strong>, you accept our <a href='#' target='_blank'>Terms & Conditions</a> and <a href='#' target='_blank'>Privacy Policy</a>.</p><p style='margin: 0; font-size: 12px; color: #666;'>This is not a substitute for advice from a qualified scholar. Use at your own discretion.</p></div>"
                // }
                const { response, disclaimer, sessionId: newSessionId } = data;
                setIsBotTyping(false);
                if (newSessionId && !sessionId) {
                    setSessionId(newSessionId);
                    dispatch(setThreadId(newSessionId));
                }
                const { welcomeMessage, options } = parseBotResponse(response);
                // setPredefinedQuestions(options);
                // messagesRef.current.push({
                //     sender: "bot",
                //     text: welcomeMessage,
                // });
                if (disclaimer) {
                    setDisclaimer(disclaimer)
                }
            } catch (error) {
                messagesRef.current.push({
                    sender: "bot",
                    text: "Oops! I couldn’t process that. Please try again.",
                });
                setTimeout(() => {
                    window.location.href = window.location.href;
                }, 2000);
            } finally {
                setIsLoading(false);
                setIsBotTyping(false);
            }
        };

        fetchWelcomeMessage();
    }, []);

    const parseBotResponse = (text) => {
        const lines = text.split('\n').map(line => line.trim()).filter(Boolean);
        const welcomeMessage = lines[0];
        const options = lines
            .slice(1)
            .filter(line => /^\d+\.\s/.test(line))
            .map(line => line.replace(/^\d+\.\s*/, ''));
        return { welcomeMessage, options };
    };

    const getTransactionNo = (data) => {
        props.setHeaderData(enrollmentMethodHeaderData)
        dispatch(updateUserSteps(enrollmentMethodHeaderData))
        console.log('data a gaya baba')
    };

    const audioQueue = [];
    let isPlaying = false;

    const playNextAudio = async () => {
        if (isPlaying || audioQueue.length === 0) return;
        isPlaying = true;
        const { audioUrl } = audioQueue.shift();
        const audio = new Audio(audioUrl);
        audio.onended = () => {
            isPlaying = false;
            URL.revokeObjectURL(audioUrl);
            playNextAudio();
        };
        try {
            await audio.play();
        } catch (error) {
            console.error("Error playing audio:", error);
            isPlaying = false;
            playNextAudio();
        }
    };

    const fileUpload = async (fileObject) => {
        setIsRemoveFile(false);
        setShowFile(false);
        let fileId = null;

        if (fileObject && fileObject?.length > 0) {
            const formData = new FormData();
            const actualFile = Array.isArray(fileObject) ? fileObject[0] : fileObject;
            formData.append('file', actualFile);
            formData.append('purpose', 'assistants');
            setIsSending(true);
            try {
                const uploadData = await OpenAIService.fileUpload(formData);
                fileId = uploadData.id;

                setFile({
                    file: fileObject,
                    fileId: fileId
                });
                setShowFile(true);
            } catch (error) {
                console.error('Error uploading file:', error);
            } finally {
                setIsSending(false);
            }
        }
        setAttachmentError('');
        return fileId;
    };

    const resetFileObject = () => setFile([]);

     // Reset recordingStatus when VoiceAssistant closes
    useEffect(() => {
        console.log('Parent: isVoiceAssistantOpen:', isVoiceAssistantOpen, 'recordingStatus:', recordingStatus);
        if (!isVoiceAssistantOpen && recordingStatus !== 'idle') {
            console.log('Parent: Resetting recordingStatus to idle');
            setRecordingStatus('idle');
            setMediaRecorder(null);
            setAudioChunks([]);
            setIsSending(false);
            isDiscardRef.current = false;
        }
    }, [isVoiceAssistantOpen]);

    const handleStartListening = async () => {
        isDiscardRef.current = false;
        if (isVoiceAssistantOpen) {
            console.warn('Cannot start dictate recording while VoiceAssistant is active');
            return;
          }
        try {
            setIsSending(true);
            setRecordingStatus('recording');
            const stream = await navigator.mediaDevices.getUserMedia({audio:true});
            // const recorder = new MediaRecorder(stream);
            let mimeType = 'audio/webm';
            if (!MediaRecorder.isTypeSupported('audio/webm') && MediaRecorder.isTypeSupported('audio/mp4')) {
              mimeType = 'audio/mp4'; // Fallback for Safari
            } else if (!MediaRecorder.isTypeSupported('audio/webm')) {
              throw new Error('No supported audio MIME type found for MediaRecorder');
            }

            const recorder = new MediaRecorder(stream, { mimeType });
            let localAudioChunks = [];
            setAudioChunks([]);

            recorder.ondataavailable = (e) => {
                if (e.data.size > 0) {
                    localAudioChunks.push(e.data);
                }
            };

            recorder.onstop = async () => {
                if (isDiscardRef.current) {
                    localAudioChunks = [];
                    setAudioChunks([]);
                    setIsSending(false);
                    setRecordingStatus('idle');
                    return;
                }

                try {
                    const audioBlob = new Blob(localAudioChunks, { type: 'audio/webm' });
                    const file = new File([audioBlob], 'audio.webm', { type: 'audio/webm' });
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('model', 'whisper-1');
                    setRecordingStatus('transcribing'); // Mark as transcribing during API call
                    const res = await OpenAIService.transcribeAudio(formData);
                    if (res) {
                        setRecordingStatus('idle');
                        setInput((prev) => prev + res);
                        setIsVoiceInput(true);
                    } else {
                        console.warn('No transcription returned.');
                        setRecordingStatus('idle'); 
                    }
                } catch (error) {
                    console.error('Error during transcription:', error);
                    setRecordingStatus('idle');
                } finally {
                    if (stream) {
                        stream.getTracks().forEach((track) => track.stop());
                    }
                    setIsSending(false);
                }
            };

            recorder.start();
            setMediaRecorder(recorder);
            setIsListening(true);
        } catch (err) {
            console.error('Microphone access denied or recording failed:', err);
            setIsSending(false);
            setRecordingStatus('idle');
        }
    };

    const handleStopListening = () => {
        if (mediaRecorder) {
            mediaRecorder.stop();
            setIsListening(false);
            setRecordingStatus('transcribing');
            if (mediaRecorder.stream) {
                const tracks = mediaRecorder.stream.getTracks();
                tracks.forEach((track) => track.stop());
            }
        }
        setIsSending(false);
    };

    const handleDiscard = () => {
        if (mediaRecorder) {
            isDiscardRef.current = true;
            mediaRecorder.stop();
            const tracks = mediaRecorder.stream.getTracks();
            tracks.forEach((track) => track.stop());
            setIsListening(false);
            setRecordingStatus('idle');
            setMediaRecorder(null);
            setAudioChunks([]);
            setInput('');
        }
    };

    const handleBotErrorResponse = (errorMessage) => {
        const fallbackMessage = "Oops! I couldn’t process the file. Please try again.";
        const text = typeof errorMessage === "string" ? errorMessage : fallbackMessage;
    
        messagesRef.current.push({
            sender: "bot",
            text,
        });
    
        stateUpdated((prev) => prev + 1);
    };
    

    const handleSend = async (messageText = input, wasVoiceInput = false) => {
        if (!messageText.trim()) return;
        let fileData = null;
        if (file?.file && file.file?.length > 0) {
            const actualFile = Array.isArray(file.file) ? file.file[0] : file.file;
            const fileToSend = actualFile;
            fileData = { name: fileToSend.name, path: fileToSend.path || "" };
        }
        messagesRef.current.push({ sender: "user", text: messageText, file: fileData });
        // Navigate to ChatBotPopup for any valid message
        setShowChat(true);

        setIsLoading(true);
        setIsBotTyping(true);
        setIsRemoveFile(true)
        setIsSending(true);
        setInput("");
        stateUpdated((prev) => prev + 1);

        try {
            const assistantId =
                promptType === "Business"
                    ? "asst_Pq6lv6O2bYS16tQKTpAiJfEZ"
                    : "asst_Ui5T87DMNf2q4WLuoV8zwJTM";

            const res = await OpenAIService.sendMessage(sessionId, messageText, file.fileId);
            if (res?.error) {
                const errorText = res.error;            
                setFile([]);
                setIsLoading(false);
                setIsRemoveFile(true);
                setIsBotTyping(false);
                setIsSending(false);
                setFileObject(null);
                handleBotErrorResponse(errorText);
                return;
            }
            liveBotResponseRef.current = "";
            const botMessage = { sender: "bot", text: "" };
            messagesRef.current.push(botMessage);
            stateUpdated((prev) => prev + 1);

            await OpenAIService.startAssistantRun(sessionId, assistantId, file.fileId, async (botChunk) => {
                liveBotResponseRef.current = botChunk;
                botMessage.text = formatResponse(liveBotResponseRef.current);
                stateUpdated((prev) => prev + 1);
            }, async (streamCompleted) => {
                const finalBotResponse = liveBotResponseRef.current;
                if (streamCompleted) {
                    if (finalBotResponse) {
                        const zakatData = extractZakatData(finalBotResponse, promptType) || {};
                        if (zakatData?.totalAmount !== undefined && zakatData.totalAmount > 0) {
                            latestZakatRef.current = zakatData;
                            if (promptType.toLowerCase() === 'business') {
                                let mainObj = zakat;
                                mainObj['business'].amount = zakatData.totalAmount
                                dispatch(updateZakatData(mainObj));
                            } else {
                                dispatch(updateZakatData(zakatData));
                            }
                            dispatch(updateAmount(zakatData.totalAmount));
                            setIsShowButton(true);
                        }
                    }
                }
            });
        } catch (error) {
            console.error("Error in OpenAI chatbot:", error);
            messagesRef.current.push({
                sender: "bot",
                text: "Oops! I couldn’t process that. Please try again.",
            });
            stateUpdated((prev) => prev + 1);
        } finally {
            setFile([])
            setIsLoading(false);
            setIsRemoveFile(true)
            setIsSending(false);
            setIsBotTyping(false);
            setFileObject(null);
        }
    };

    const handleProceedToPay = () => {
        const lastUserMessage = messagesRef.current
            .slice()
            .reverse()
            .find((msg) => msg.sender === "user");
        if (lastUserMessage) {
            const zakatData = latestZakatRef.current;
            if (zakatData?.totalAmount && zakatData?.totalAmount > 0) {
                getTransactionNo(zakatData);
            } else {
                console.log("No zakat amount available for transaction.", zakatData);
            }
        }
    };

    const handleZakatData = (zakatData) => {
        latestZakatRef.current = zakatData;
        setIsShowButton(true);
    };

    const updateMessage = (message) => {
        messagesRef.current.push(message);
        stateUpdated(prev => prev + 1);
    };

    const handleClosePopup = (status = false) => {
        if(status) {
            setShowChat(true); // Navigate to ChatBotPopup for voice assistant
            // setIsVoiceOptionEnabled(true)
        } else {
            // setIsVoiceOptionEnabled(false)
        }
    }


    const headerTitle = 'Ai Amil';
    const headerSubtitle = 'Chat with our';

    const handleBack = () => {
        props.setHeaderData(optionsHeaderData)
        dispatch(updateUserSteps(optionsHeaderData))
    }

    return (
        <>
            <div className='chatBot-fluid'>
                <button className="btn ai-back-btn btn-transparent" onClick={handleBack}>
                   
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
  <g id="Group_19809" data-name="Group 19809" transform="translate(-0.217)">
    <circle id="Ellipse_925" data-name="Ellipse 925" cx="17" cy="17" r="17" transform="translate(0.217)" fill="#e8e8e8"/>
    <path id="close-svgrepo-com" d="M4.714,5.749A.732.732,0,1,1,5.749,4.714L9.987,8.952l4.238-4.238a.732.732,0,1,1,1.035,1.035L11.021,9.987l4.238,4.238a.732.732,0,1,1-1.035,1.035L9.987,11.021,5.749,15.259a.732.732,0,1,1-1.035-1.035L8.952,9.987Z" transform="translate(7.121 7.122)" fill="#4c4c4c" stroke="#4c4c4c" stroke-width="0.5" fill-rule="evenodd"/>
  </g>
</svg>

                            </button>
                {showChat ? (
                    <ChatBotPopup
                        onClose={() => setShowChat(false)}
                        messages={messagesRef}
                        predefinedQuestions={predefinedQuestions}
                        input={input}
                        setInput={setInput}
                        handleSend={handleSend}
                        nisabValue={homepage.muisZakatHarta?.nisab?.value}
                        headerTitle={headerTitle}
                        headerSubtitle={headerSubtitle}
                        isTyping={isBotTyping}
                        liveBotResponse={liveBotResponseRef}
                        isShowButton={isShowButton}
                        paymentProceed={handleProceedToPay}
                        updateMessage={updateMessage}
                        isSending={isSending}
                        showEmojiPicker={showEmojiPicker}
                        setShowEmojiPicker={setShowEmojiPicker}
                        fileUpload={fileUpload}
                        isRemoveFile={isRemoveFile}
                        setAttachmentError={setAttachmentError}
                        attachmentError={attachmentError}
                        showFile={showFile}
                        resetFileObject={resetFileObject}
                        isVoiceInput={isVoiceInput}
                        isListening={isListening}
                        mediaRecorder={mediaRecorder}
                        inputRef={inputRef}
                        handleStartListening={handleStartListening}
                        handleStopListening={handleStopListening}
                        handleDiscard={handleDiscard}
                        onClosePopup={handleClosePopup}
                        onZakatData={handleZakatData}
                        recordingStatus={recordingStatus}
                    />
                ) : (
                    <div className="chatBot-start">
                        {/* <div className='chatBot-header-main'> */}
                            {/* <div className="chatBot-header"> */}
                            {/* <div className='bank-btn'>
                                    <button onClick={() => history.push('/')} className='btn'>
                                        {imgBack}
                                    </button>
                                </div> */}
                            {/* <div className='chatBot-header-container'> */}
                            {/* <div className="chatBot-header-left">
                                        <figure>
                                            <Suspense fallback={null}>
                                                <ImageLoader type='image' src={USTAD_ICON} />
                                            </Suspense>
                                        </figure>
                                        <figcaption>
                                            <h3>{headerSubtitle}</h3>
                                            <h2>{headerTitle}</h2>
                                        </figcaption>
                                    </div> */}
                            {/* <div className="chatBot-header-right">
                                        <div className='nisab-value'>
                                            <p>{t('Home_nisab_month_text')} : <b>{commaSeperatedAmount(CURRENCY_SYMBOL, homepage.muisZakatHarta?.nisab?.value ?? 0)} ({moment().format('MMMM') + ' ' + moment().format('YYYY')})</b></p>
                                            <a href="https://zakat.sg/current-past-nisab-values/" target="_blank" rel="noreferrer">{t('Home_nisab_view_all_text')}</a>
                                        </div>
                                    </div> */}
                            {/* </div> */}
                            {/* <div className='header-icon'> */}
                            {/* {HEAD_ICON} */}
                            {/* </div> */}
                            {/* </div> */}
                        {/* </div> */}
                        <div className="chatBot-start-main">
                            <figure>
                                {/* {CHAT_HEAD} */}
                                <Suspense fallback={null}>
                                    <ImageLoader type='image' src={AMIL_ICON} />
                                </Suspense>
                            </figure>
                            <figcaption>
                              <div className='chatBot-head'> 
                                    <h2>Welcome to the <br /> <span> Ai Amil</span></h2>
                                    <p>Your Simple Guide to  <br/> Accurate Zakat Calculation.</p>
                              </div>
                                <div className='chat-sec'>
                                    <div className="chatBot-initial-toolbar">
                                        <ChatToolbar
                                            input={input}
                                            setInput={setInput}
                                            onSendMessage={handleSend}
                                            isSending={isSending}
                                            isLoading={isLoading}
                                            isTyping={isBotTyping}
                                            isListening={isListening}
                                            mediaRecorder={mediaRecorder}
                                            inputRef={inputRef}
                                            handleStartListening={handleStartListening}
                                            handleStopListening={handleStopListening}
                                            handleDiscard={handleDiscard}
                                            showEmojiPicker={showEmojiPicker}
                                            setShowEmojiPicker={setShowEmojiPicker}
                                            fileUpload={fileUpload}
                                            isRemoveFile={isRemoveFile}
                                            setAttachmentError={setAttachmentError}
                                            attachmentError={attachmentError}
                                            showFile={showFile}
                                            resetFileObject={resetFileObject}
                                            updateMessage={updateMessage}
                                            onClosePopup={handleClosePopup}
                                            showVoiceAssistant={true}  // Show Voice Assistant
                                            showDictate={true}// shiw Dictate option
                                            onZakatData={handleZakatData}
                                            recordingStatus={recordingStatus}
                                        />
                                    </div>
                                    {isDisclaimer && (
                                    <p
                                        className="msg-text"
                                        dangerouslySetInnerHTML={{
                                            __html: isDisclaimer,
                                        }}
                                    ></p>
                                    )}
                                </div>
                                
                            </figcaption>
                        </div>
                    </div>
                )}
            </div>
            {(isPaymentLoading || isMounted) && (
                <div className='c-loader'><Loader /></div>
            )}
        </>
    );
};

export default IslamicChatBot;